import { Module } from '@nestjs/common';
import { UnitCodesController } from './unit-codes.controller';
import { UnitCodesService } from './unit-codes.service';
import {UnitCodes} from './unit-codes.entity'
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
import {UnitcodeAdapter} from './dto/unit-codes.adapter'
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([UnitCodes]),
    ],

  controllers: [UnitCodesController],
  providers: [ UnitcodeAdapter ,UnitCodesService,ApplicationExceptionHandler,LogsService]
})
export class UnitCodesModule {}
